import { Component, OnInit } from '@angular/core';
import { FileItem } from '../../../models/adduser/adduser/adduser.module';
import { AddUsersService } from '../../../services/add-users.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { stringify } from 'querystring';
import { UserService } from '../../../services/user.service';
import { CategoryService } from '../../../services/category.service';
import { TareasService } from '../../../services/tareas.service';
import { GLOBAL_IMAGES } from '../../../services/global.service';
import { DelTask } from '../../../models/tarea/tarea.module';
import { Location } from '@angular/common';
import { Estatus } from '../../../models/category/category.module';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mitrabajo',
  templateUrl: './mitrabajo.component.html',
  styleUrls: ['./mitrabajo.component.css']
})
export class MitrabajoComponent implements OnInit {
  url: string;
  token: string;
  tarea: DelTask;
  datos_tareas: any;
  ver_tarea: any;
  ver_info: boolean = false;
  realizadas: boolean = false;
  estatus: Estatus;
  constructor(private _userService: UserService, private _categoryService: CategoryService, private _tareasService: TareasService, private _location: Location) {

    this.url = GLOBAL_IMAGES.url;
    const user = this._userService.getIdentity();
    const token = this._userService.getToken();
    this.token = token;
    this.tarea = new DelTask(0, user.sub);
    this.verTareas();
  }
  ngOnInit(): void {
    this.verTareas();
  }
  backClicked() {
    this._location.back();
  }
  verTareas() {
    this.realizadas = false;
    this._tareasService.TareasUsuario(this.tarea, this.token).subscribe(
      response => {
        this.datos_tareas = response;
        console.log(this.datos_tareas);

      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }
  verTareasRealizadas() {
    this.realizadas = true;
    this._tareasService.TareasUsuarioRealizadas(this.tarea, this.token).subscribe(
      response => {
        this.datos_tareas = response;
      },
      error => {
        console.log(error);
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }

  onSubmitImportancia(form) {
    console.log('click');
    console.log(form.value);

    this.datos_tareas.tareas[form.value.num].num_importancia = form.value.importancia;
    if (form.value.importancia == 1) {
      this.datos_tareas.tareas[form.value.num].importancia = 'Bajo';
      this.datos_tareas.tareas[form.value.num].importancia_color = 'badge-success';
    } else if (form.value.importancia == 2) {
      this.datos_tareas.tareas[form.value.num].importancia = 'Media';
      this.datos_tareas.tareas[form.value.num].importancia_color = 'badge-info';
    } else if (form.value.importancia == 3) {
      this.datos_tareas.tareas[form.value.num].importancia = 'Alta';
      this.datos_tareas.tareas[form.value.num].importancia_color = 'badge-danger';
    } else {
      this.datos_tareas.tareas[form.value.num].importancia = 'Importancia';
      this.datos_tareas.tareas[form.value.num].importancia_color = 'badge-success';
    }

    this.estatus = new Estatus(form.value.id_tarea, form.value.importancia, form.value.num);
    this._categoryService.editImportancia(this.estatus, this.token).subscribe(
      response => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se actualizó la importancia correctamente',
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
        console.log(error);
      }
    );

  }
  onSubmitEstatus(form) {
    this.estatus = new Estatus(form.value.id_tarea, form.value.estatus, form.value.num);
    //console.log(this.estatus);
    this.datos_tareas.tareas[form.value.num].id_estatus = form.value.estatus;

    this._categoryService.editEstatus(this.estatus, this.token).subscribe(
      response => {
        this.datos_tareas.tareas[form.value.num].estatus = response.estatus;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se actualizó el estatus correctamente',
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
        console.log(error);
      }
    );
  }
  abrirInfo(tarea) {
    this.ver_info = true;
    this.ver_tarea = tarea;
  }
  cerrarInfo() {
    this.ver_info = false;
  }

}
